import Vue from 'vue'
import { CHANGE_LANGUAGE } from '../mutation-types'

const state = {
    lang: 'pt-BR'
}

const mutations = {
    [CHANGE_LANGUAGE] (state, lang) {
        Vue.config.lang = lang
        state.lang = lang
        localStorage.setItem('app_lang', lang)
    },
}

export default {
    state,
    mutations
}



// WEBPACK FOOTER //
// ./src/vuex/settings/store.js